import { render } from "./sipNumber.vue?vue&type=template&id=51fe3e0f&scoped=true"
import script from "./sipNumber.vue?vue&type=script&lang=js"
export * from "./sipNumber.vue?vue&type=script&lang=js"

import "./sipNumber.vue?vue&type=style&index=0&id=51fe3e0f&scoped=true&lang=css"
import "./sipNumber.vue?vue&type=style&index=1&id=51fe3e0f&lang=css"
script.render = render
script.__scopeId = "data-v-51fe3e0f"

export default script